var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.999,
    height: 45.002,
    viewBox: "0 0 39.999 45.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcbc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2d301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_12"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3661",
    "data-name": "Group 3661",
    transform: "translate(-159.999 -255.999)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12-2",
    "data-name": "Subtraction 12",
    d: "M-2213-15790l-20-10v-25l20-10,20,10v25l-20,10Zm-2.015-16.234v4.232h4.364v-4.232Zm2.007-14.021a2.741,2.741,0,0,1,2.381.918,3.431,3.431,0,0,1,.652,2.027,2.966,2.966,0,0,1-.584,1.772,3.869,3.869,0,0,1-.85.866l-1.07.834a6.058,6.058,0,0,0-1.963,2.174,11.609,11.609,0,0,0-.469,3.422h3.954a6.349,6.349,0,0,1,.191-1.729,3.177,3.177,0,0,1,1.129-1.538l1.037-.807a11.038,11.038,0,0,0,2.142-2.019,5.341,5.341,0,0,0,.95-3.211,5.422,5.422,0,0,0-2.19-4.686,9.168,9.168,0,0,0-5.5-1.582,7.722,7.722,0,0,0-4.248,1.113c-1.818,1.157-2.8,3.147-2.913,5.917h4.232a4.331,4.331,0,0,1,.711-2.345A2.633,2.633,0,0,1-2213.008-15820.254Z",
    transform: "translate(2393 16091)",
    fill: "url(#linear-gradient9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 160, 256)",
    filter: "url(#Subtraction_12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12-3",
    "data-name": "Subtraction 12",
    d: "M-2213-15790l-20-10v-25l20-10,20,10v25l-20,10Zm-2.015-16.234v4.232h4.364v-4.232Zm2.007-14.021a2.741,2.741,0,0,1,2.381.918,3.431,3.431,0,0,1,.652,2.027,2.966,2.966,0,0,1-.584,1.772,3.869,3.869,0,0,1-.85.866l-1.07.834a6.058,6.058,0,0,0-1.963,2.174,11.609,11.609,0,0,0-.469,3.422h3.954a6.349,6.349,0,0,1,.191-1.729,3.177,3.177,0,0,1,1.129-1.538l1.037-.807a11.038,11.038,0,0,0,2.142-2.019,5.341,5.341,0,0,0,.95-3.211,5.422,5.422,0,0,0-2.19-4.686,9.168,9.168,0,0,0-5.5-1.582,7.722,7.722,0,0,0-4.248,1.113c-1.818,1.157-2.8,3.147-2.913,5.917h4.232a4.331,4.331,0,0,1,.711-2.345A2.633,2.633,0,0,1-2213.008-15820.254Z",
    transform: "translate(2233 15835)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.2dae4c9b6147f6763aedf6f3b98b6018.svg";
export { ForwardRef as ReactComponent };